module.exports = __webpack_public_path__ + "static/media/facebook-iconTenerif.cacd7f2b.png";